import {createFeatureSelector, createSelector} from '@ngrx/store';
import {ResumoNgrx} from '~model/ngrx/resumo-ngrx';

export const featureKeyResumo = 'resumo';
export const selectFeature = createFeatureSelector<ResumoNgrx>(featureKeyResumo);

export const getResumo = createSelector(selectFeature, (state) => state);
